exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.step-remarks[data-v-28af824a] {\n  white-space: pre-wrap;\n}\n", ""]);
